/* Dansk katalog for locale-firm-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'rf.loading.firm': 'Indlæser dit bureau …',
  'rf.loading.clients': 'Henter dine klienter …',
  'rf.loading.reconciliation': 'Henter afstemningerne …',
  'rf.loading.control': 'Henter kontrolopgaverne …',
  'rf.loading.ledger': 'Indlæser klientens regnskab …',
  'rf.pageError.title': 'Siden kunne ikke indlæses',
  'rf.pageError.text': 'Indlæs bureauvisningen igen. Fortsætter det, er scriptet til denne side ikke tilgængeligt.',
  'rf.client.assignCount': 'Tildel ({count})',
  'rf.client.assignAll': 'Alle i bureauet',
  'rf.client.assignNobody': 'Bureauet har endnu ingen aktive medarbejdere at tildele opgaven.',
  'rf.client.assignRoleHint': 'Rollen gælder alle, du har sat kryds ved. Er nogen allerede tildelt, får de den nye rolle.',
  'rf.client.assignedMany': '{count} medarbejdere er tildelt opgaven',
  'rf.nav.myPage': 'Min side',
  'rf.nav.firmBooks': 'Til bureauets regnskab',
});
